var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loader"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7,"color":"primary"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }